import * as fromOrganization from './organization.actions';
import { createReducer } from '@reduxjs/toolkit';
import { Organization } from '../models/organization.model';

export interface IOrganizationState {
  organizationInfo: Organization | null;
  organizationCode: string;
  isLoading: boolean;
}

export const initialState: IOrganizationState = {
  organizationInfo: null,
  organizationCode: 'geco',
  isLoading: false
};

export const organizationReducer = createReducer(initialState, (builder) => {
  builder.addCase(fromOrganization.fetchOrganizationAction, (state, action) => {
    return {
      ...state,
      organizationInfo: null,
      organizationCode: action.payload,
      isLoading: true
    };
  });
  builder.addCase(fromOrganization.storeOrganizationAction, (state, action) => {
    return {
      ...state,
      organizationInfo: action.payload,
      organizationCode: action.payload.code,
      isLoading: false
    };
  });
});
